Auth = require 'db/auth'
Util = require 'lib/util'
View = require 'view'
track = require 'debug/track'

module.exports = class AdView extends View
  events: ->
    'click': @click
    'click .js-close-ad': @close

  @isEligible: (member) ->
    false

  getAdId: ->
    @constructor.adId

  click: ->
    track('Ad', @getAdId(), 'Click')

  close: (e) ->
    Util.stop(e)

    if (adId = @getAdId())?
      track('Ad', @getAdId(), 'Dismiss')
      Auth.me().dismissAd(adId)

    @$el.slideUp(100)



// WEBPACK FOOTER //
// ./app/scripts/views/ads/ad-view.coffee